var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024.003",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M731.427 182.857H109.714C49.12 182.857 0 231.977 0 292.57v621.714c0 60.594 49.12 109.714 109.714 109.714h621.713c60.594 0 109.714-49.12 109.714-109.714V292.57c0-60.593-49.12-109.713-109.713-109.713zM768 914.287c0 20.2-16.375 36.572-36.573 36.572H109.714c-20.2 0-36.572-16.375-36.572-36.573V292.572c0-20.2 16.374-36.572 36.572-36.572h621.713c20.2 0 36.572 16.374 36.572 36.572v621.715zM914.285 0H256c-60.593 0-109.713 49.122-109.713 109.715 0 20.2 16.374 36.572 36.572 36.572s36.57-16.374 36.57-36.572S235.802 73.143 256 73.143h658.286c20.2 0 36.572 16.374 36.572 36.572V768c0 20.2-16.374 36.572-36.572 36.572s-36.572 16.374-36.572 36.572 16.374 36.572 36.572 36.572c60.594 0 109.714-49.12 109.714-109.714V109.715C1024 49.12 974.88 0 914.286 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.dc98c464cbb3b5d220c0c5c79742263c.svg";
export { ForwardRef as ReactComponent };